<template>
  <li>
    <div class="row mb-4" v-if="message.sender_type === 'user'">
      <div class="col-10 col-sm-10 col-md-9 col-lg-10 p-0">
        <div class="panel-quote-flush panel-quote card panel-quote-right">
          <div class="card-body panel-dark">
            <span v-if="Number(message.message_type_id) === 1"
                  v-html="$options.filters.replaceUrl(message.message)">
            </span>
            <template v-else-if="Number(message.message_type_id) === 2">
              <a :href="message.image_xl" target="_blank">
                <img class="img-fluid" v-lazy="message.image_sm">
              </a>
            </template>
            <template v-else>
              <div class="embed-responsive embed-responsive-16by9" v-if="center">
                <div class="embed-responsive-item">
                  <gmap-map ref="gmap"
                            :center="center"
                            :zoom="14"
                            style="width: 100%; height: 100%">
                    <gmap-marker v-for="(marker, index) in markers"
                                 :key="'marker'+index"
                                 :position="marker.position"
                                 :icon="marker.icon">
                    </gmap-marker>
                  </gmap-map>
                </div>
              </div>
            </template>
            <div class="message-time">{{ message.create_date | timeSpan }}
              <i class="fas fa-check-double" v-if="parseFloat(message.is_read) === 1"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2 col-sm-2 col-md-3 col-lg-2 text-right p-0">
        <img v-if="user.picture" v-lazy="user.picture" class="rounded-circle message-user-img"
             alt="user image">
      </div>
    </div>
    <!-- /.row -->
    <div class="row mb-4" v-else>
      <div class="col-2 col-sm-2 col-md-3 col-lg-2 text-left p-0">
        <div class="avatar-container small">
          <div :class="['dot', (professional.active === 1) ? 'active' : 'inactive']"></div>
          <img v-if="professional" v-lazy="professional.picture" class="rounded-circle message-user-img"
               alt="cleaner image">
        </div>
      </div>
      <div class="col-10 col-sm-10 col-md-9 col-lg-10 p-0">
        <div class="panel-quote-flush panel-quote card panel-quote-left">
          <div class="card-body">
            <span v-if="Number(message.message_type_id) === 1"
                  v-html="$options.filters.replaceUrl(message.message)">
            </span>
            <template v-else-if="Number(message.message_type_id) === 2">
              <a :href="message.image_xl" target="_blank">
                <img class="img-fluid" v-lazy="message.image_sm">
              </a>
            </template>
            <template v-else>
              <div class="embed-responsive embed-responsive-16by9" v-if="center">
                <div class="embed-responsive-item">
                  <gmap-map ref="gmap"
                            :center="center"
                            :zoom="14"
                            style="width: 100%; height: 100%">
                    <gmap-marker v-for="(marker, index) in markers"
                                 :key="'marker'+index"
                                 :position="marker.position"
                                 :icon="marker.icon">
                    </gmap-marker>
                  </gmap-map>
                </div>
              </div>
            </template>
            <div class="message-time">{{ message.create_date | timeSpan }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { loaded } from 'vue2-google-maps'

  export default {
    props: ['message'],
    data () {
      return {
        center: null,
        markers: null,
        icon: null,
        time: null,
        googleMapsInitialized: false
      }
    },
    computed: {
      ...mapGetters({
        professional: 'professional/getProfessional',
        user: 'auth/getUser'
      })
    },
    methods: {
      setLocationData (latitude, longitude) {
        setTimeout(() => {
          this.center = {lat: latitude, lng: longitude}
          this.markers = []
          this.markers[0] = {
            position: {lat: latitude, lng: longitude}
          }
        }, 500)
      },
      setBounds () {
        // Set boundary to see all markers in map
        setTimeout(() => {
          if (this.googleMapsInitialized) {
            let bounds = new window.google.maps.LatLngBounds()
            for (let i = 0; i < this.markers.length; i++) {
              bounds.extend(this.markers[i].position)
            }
            this.$refs.gmap.fitBounds(bounds)
          }
        }, 500)
      }
    },
    async mounted () {
      if (Number(this.message.message_type_id) === 3) {
        const jsonObject = JSON.parse(this.message.message)
        const latitude = jsonObject.latitude
        const longitude = jsonObject.longitude
        this.setLocationData(latitude, longitude)
      }
      if (loaded) {
        loaded.then(() => {
          this.googleMapsInitialized = true
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/message/Message.vue